// extracted by mini-css-extract-plugin
export default {"Body":"Ue_wMwa7"};